export class BaseComponent {
    constructor(config = {}) {
        this.config = config;
        this.state = {};
        this.element = null;
        this.id = crypto.randomUUID();
    }

    setState(newState) {
        this.state = { ...this.state, ...newState };
        this.update();
    }

    update() {
        if (this.element) {
            const newElement = this.render();
            if (newElement && this.element.parentNode) {
                this.element.parentNode.replaceChild(newElement, this.element);
                this.element = newElement;
                this.afterUpdate();
            }
        }
    }

    render() {
        try {
            // Style'ı head'e ekle
            const styles = this.style();
            if (styles) {
                const styleId = `style-${this.id}`;
                let styleElement = document.getElementById(styleId);

                if (!styleElement) {
                    styleElement = document.createElement('style');
                    styleElement.id = styleId;
                    styleElement.textContent = styles;
                    document.head.appendChild(styleElement);
                }
            }

            // Template'i oluştur
            const template = this.createTemplate();
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = template.trim();

            const element = tempDiv.firstElementChild;
            if (!element) {
                throw new Error('Template geçerli bir HTML elementi döndürmedi');
            }

            // Event listener'ları ekle
            if (typeof this.addEventListeners === 'function') {
                this.addEventListeners(element);
            }

            this.element = element;
            return element;
        } catch (error) {
            console.error('Render hatası:', error);
            return document.createElement('div');
        }
    }

    mount(container) {
        try {
            if (typeof container === 'string') {
                container = document.querySelector(container);
            }

            if (!container) {
                throw new Error('Geçerli bir container elementi bulunamadı');
            }

            const element = this.render();
            container.innerHTML = '';
            container.appendChild(element);
            this.afterMount();
        } catch (error) {
            console.error('Mount hatası:', error);
        }
    }

    style() {
        return '';
    }

    createTemplate() {
        return '<div></div>';
    }

    // Lifecycle hooks
    afterMount() { }
    afterUpdate() { }
    beforeDestroy() { }

    destroy() {
        try {
            if (this.element) {
                this.beforeDestroy();
                const styleElement = document.getElementById(`style-${this.id}`);
                if (styleElement) {
                    styleElement.remove();
                }
                this.element.remove();
                this.element = null;
            }
        } catch (error) {
            console.error('Destroy hatası:', error);
        }
    }
}